import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const [open, setOpen] = React.useState(false); 
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function startClassTest(){ 
    setOpen(false);
    props.toCallStartTest();
	}
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.testDetail.testTitle}</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        {props.testDetail.testType===2?<>
                          <tr style={{backgroundColor:'#FFFFFF'}} >
                              <td>Subject</td>
                              <td style={{textAlign:'center'}} >{props.testDetail.subject}</td>
                          </tr>
                        </>:null}
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Date/Time</td>
                            <td style={{textAlign:'center'}} >{moment(props.testDetail.testDateTime).format('DD-MM-YYYY HH:mm')}</td>                            
                        </tr>                        
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Total time for Test (minutes)</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.totalTime}</td>
                        </tr>
                        
                        {props.testDetail.testType===2?<>
                          <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Correct Marks</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.markCorrectAns}</td>                            
                          </tr>
                          <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Wrong Marks</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.markIncorrectAns}</td>
                          </tr>
                          <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Not Answered Marks</td>
                            <td style={{textAlign:'center'}} >{props.testDetail.markNotAttempt}</td>
                          </tr>
                          <tr style={{backgroundColor:'#FFFFFF'}} >
                              <td>Total Questions</td>
                              <td style={{textAlign:'center'}} >{props.testDetail.totalQuestion}</td>                            
                          </tr>
                          <tr style={{backgroundColor:'#FFFFFF'}} >
                              <td>Question Type</td>
                              <td style={{textAlign:'center'}} >{props.testDetail.questionType}</td>
                          </tr>                        
                          <tr style={{backgroundColor:'#FFFFFF'}} >
                              <td>Total Marks</td>
                              <td style={{textAlign:'center'}} >{props.testDetail.totalMark}</td>
                          </tr> 
                        </>:null}    

                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {startClassTest()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Start Test</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>        
    </>
  );

});

export default CustomizedDialogs;